export const SearchCabysComponent = {
  templateUrl: './app/ajs/_shared/components/search-cabys/search-cabys.component.html',
  bindings: {
    item: '<',
    onSavedItem: '&',
  },
  controller: SearchCabysController,
  controllerAs: 'vm',
};

SearchCabysController.$inject = ['ProductService'];

function SearchCabysController(ProductService) {
  const vm = this;

  // public properties
  // -----------------------
  vm.filterByText = '';
  vm.searchApplied = false;

  vm.filterByTypes = ['code', 'description'];

  vm.filterByType = vm.filterByTypes[0]; // code by default
  // vm.filterByTextPattern = 'numbers';

  vm.$onInit = function () {
    setTimeout(() => {
      // hack
      var element = document.querySelector('input[name="search_text"]'); // <HTMLInputElement>
      element.focus(); // not working if open twice
    }, 500);
  };

  // public methods
  // -----------------------
  vm.selectFilterByType = function (type) {
    // vm.filterByText = '';

    setTimeout(() => {
      // hack
      document.querySelector('input[name="search_text"]').focus();
      //var element = <HTMLInputElement>document.querySelector('input[name="search_text"]');
      //element.focus();
    }, 100);
  };

  vm.searchCabys = function (isFormValid) {
    if (!isFormValid) return;

    let searchBy = vm.filterByType === 'code' ? 'codigo' : 'q';
    searchBy += '=' + vm.filterByText.toLowerCase();

    vm.searchApplied = true;

    vm.loadingProducts = true;
    ProductService.searchCabys(searchBy).then(function (data) {
      vm.products = data.cabys || data;

      vm.loadingProducts = false;
    });
  };

  vm.clearSearch = function () {
    vm.filterByText = '';

    vm.searchApplied = false;
  };

  vm.selectProduct = function (product) {
    // console.log(product);
    // return;

    vm.onSavedItem({ item: product });

    // vm.productSelected({ $event: product })
  };
}
